export const questionnaireIntialState={
    recruiterId: 0,
    corpId: 0,
    name: "",
    description: "",
    essayQuestion: "",
    minimumEligibilityPoint: 0,
    objectiveQuestions: [
      {
        index: 1,
        question: "",
        answer: "yes",
        points: 0
      }
    ]
  }